<template>
  <div class="main-container">
    <div class="paycontainer">
        <div class="paybox">
            <h2 v-if="this.$cookies.isKey('orders_data')==false">暂无订单信息</h2>
            <div v-if="this.$cookies.isKey('orders_data')">
              <h2>订单已成功提交,请尽快付款</h2>
              <p>感谢您购买刘燕酿制产品,<b class="ordersNum">订单号为:{{ordersNum}}</b></p>
              <div class="payboxBottom">
                <div class="tips">
                  <div class="box">
                    <div class="clock">
                      <span class="min" :style="{transform:' rotateZ('+min*12+'deg)'}"></span>
                      <span class="sec" :style="{transform:' rotateZ('+sec*6+'deg)'}"></span>
                      <span class="dot"></span>
                    </div>
                    <span style="font-size:14px">等待支付中，支付成功后，自动跳转订单详情</span>    
                    <p style="padding-top:.3rem;font-size:.2rem;letter-spacing: 0.3em;text-align: center;">还剩<strong class="timeNum">{{min}}</strong>分<strong class="timeNum">{{sec}}</strong>秒</p>
                  </div>
                </div>                
                <div class="pryerweima">
                  <div class="qrcode" ref="qrCodeUrl"></div>
                  <b class="ordersTotal">订单金额:￥{{ordersTotal}}</b>
                  <p style="padding-top: 0.3rem;">请使用微信扫描二维码即可付款</p>
                </div>                
              </div>

            </div>
        </div>
    </div>

  </div>
</template>

<script>
import { orderDetail_url } from '../request/api'
import QRCode from 'qrcodejs2'
  export default {
    name: "Pay",
    data() {
      return {
        orders_data: {},
        ordersNum: 12314654,
        ordersId: 12314654,
        ordersTotal: 0,
        payQR: '',
        timer:'',
        timer:'',
        min:'__',
        sec:'__'
      }
    },
    methods: {
      creatQrCode() {
        var qrcode = new QRCode(this.$refs.qrCodeUrl, {
            text: this.orders_data.qrcode, // 需要转换为二维码的内容
            width: 100,
            height: 100,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
        })
    },
    orderDetail() {
        setTimeout(()=>{
          let  data= {id: this.ordersId};
            console.log(data)
          orderDetail_url(data).then((res)=>{
            if(res.data.code===200 || res.data.code===204){
              this.$cookies.remove('orders_data');
               this.$cookies.set('ordersId', this.ordersId)
              this.$router.push({name:'Orders_i',params:{id:this.ordersId}})
            }else if(res.data.code===401){
              this.$router.push({path: '/Login'});
            }else{
              this.orderDetail()
            }
          })
        },2000)
      },
      showTime(){
        const inTime=new Date().getMinutes()
        this.timer = setInterval(()=>{
          this.min=29-(new Date().getMinutes()-inTime)
          this.sec=59-new Date().getSeconds()
          if(this.min<1 && this.sec<1){this.$router.push({path:'/Information',query:{id:'orderslist'}})}
        },1000)
      }
    },
    mounted() {
      if (!this.$store.state.isLogin) {
        this.$router.push({path: "/login"});
      }

      if (this.$cookies.isKey('orders_data')) {//判断是否有cookie
        this.orders_data = this.$cookies.get('orders_data');//获取cookie
        console.log(this.orders_data)
        this.ordersNum = this.orders_data.order_num;
        this.ordersId = this.orders_data.id;
        this.ordersTotal = this.orders_data.total_price;
        this.payQR = this.orders_data.qrcode;
        this.showTime()
        this.orderDetail();
         this.creatQrCode();
      };
    },
    beforeDestroy() {
      clearInterval(this.timer);
    }
  }

</script>

<style lang="less" scoped>
.paycontainer{
        width: 100%;
        // min-height:calc(100vh - 300px);
        color: #00383F;
        .ordersTotal{padding: 15px 0;}
        .paybox{
          text-align: center;
          max-width: 1300px;
          margin: 0 auto;
          padding: 4% 15px;
          h2{
            font-size: 30px;
            font-weight: 400;
          }
          p{
            font-size: 20px;
            margin: 1% 0;
          b{
            font-weight: 400;
          }
          }
          
          .tips{
            padding-bottom: 1%;
            overflow: hidden;
            .box{
              // min-height: 4rem;
            }
            display: flex;
            align-items: center;
            justify-content: center;
            .timeNum{font-size: .4rem;}
            .clock{
              margin: 0 auto;
              width: 1.3rem;
              height: 1.3rem;
              background-color: #44b549;
              border-radius: 50%;
              position: relative;
              transform: rotateY(180deg);
              margin-bottom: .3rem;
              span{
                position: absolute;
                background-color: #fff;
                box-shadow: 0.01rem 0.01rem 0.05rem #1d4e20;
                left: 50%;
                top: 50%;
              }
            }
            .min{
              width: .09rem;
              height: .6rem;
              border-radius: 1rem;
              margin-left: -0.045rem;
              margin-top: -0.5rem;
              transform-origin: 0.045rem 0.5rem;
            }
            .sec{
              width: .06rem;
              height: .7rem;
              border-radius: 1rem;
              margin-left: -.03rem;
              margin-top: -.6rem;
              transform-origin: .03rem .6rem;
            }
            .dot{
              width: .16rem;
              height: .16rem;
              border-radius: 1rem;
              margin-left: -.08rem;
              margin-top: -.08rem;
            }
          }
          .payboxBottom{
            border-top: 1px solid #00383F;
            display: flex;
            justify-content: space-around;
            align-items: center;
            padding: .3rem 0;
          }
          .pryerweima{
            p{
                font-size: 30px;
                font-weight: 400;
            }
             
       
          }
          .qrcode{
            display: flex;
            justify-content: center;
            max-width: 150px;
            margin: 0 auto .3rem;
            padding-top: 5%;
          }
          
        }
}
</style>


// WEBPACK FOOTER //
// src/view/Pay.vue